'use client'

import { useFocusMode } from '~/components/FocusModeProvider'
import { cn } from '~/lib/utils'

export default function FocusModeToggleButton({ className }: { className?: string }) {
  const { focusMode, toggle } = useFocusMode()

  return (
    <button
      type="button"
      onClick={toggle}
      title={focusMode ? 'Fokusmodus beenden' : 'Fokusmodus aktivieren'}
      aria-label={focusMode ? 'Fokusmodus beenden' : 'Fokusmodus aktivieren'}
      className={cn(
        'flex items-center justify-center h-8 w-8 rounded-md bg-gray-100 hover:bg-gray-200 text-gray-500 hover:text-gray-800 transition-colors',
        className,
      )}
    >
      {focusMode ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-4 w-4"
        >
          <polyline points="4 14 10 14 10 20" />
          <polyline points="20 10 14 10 14 4" />
          <line x1="14" y1="10" x2="21" y2="3" />
          <line x1="3" y1="21" x2="10" y2="14" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-4 w-4"
        >
          <polyline points="15 3 21 3 21 9" />
          <polyline points="9 21 3 21 3 15" />
          <line x1="21" y1="3" x2="14" y2="10" />
          <line x1="3" y1="21" x2="10" y2="14" />
        </svg>
      )}
    </button>
  )
}
